import { Box, Flex, Link } from "@chakra-ui/layout";
import { Image, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { getIconForFileExt, isImage, isSvg } from "infra/helpers/file";
import { Tooltip } from "antd";

interface ListaArquivosProps {
  arquivos: {
    referencia: string;
    nome?: string | undefined;
    descricao?: string | undefined;
  }[];
}

const ArquivoItem = ({
  arquivo,
}: {
  arquivo: {
    referencia: string;
    nome?: string | undefined;
    descricao?: string | undefined;
  };
}) => {
  const ext = arquivo.referencia?.split(".").pop();
  const _isImage = isImage(ext!);
  const _isSvg = isSvg(ext!);
  const _nome = arquivo.referencia.split("/").pop();

  return (
    <Tooltip
      title={`${arquivo.nome || _nome}`}
      placement="bottom"
      overlayInnerStyle={{
        width: "fit-content",
        textAlign: "center",
      }}
    >
      <Flex flexDir="column" w="152px">
        <Flex
          rounded="6px"
          borderColor={colors.gray}
          borderWidth={2}
          position="relative"
          flexDir="column"
          w="152px"
          h="120px"
          overflow="visible"
        >
          <Link
            w="100%"
            h="100%"
            display="flex"
            flexDir="column"
            href={arquivo.referencia}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box w="100%" h="80px">
              {_isImage || _isSvg ? (
                <Image
                  w="100%"
                  h="100%"
                  src={arquivo.referencia}
                  objectFit="fill"
                  roundedTop="4px"
                />
              ) : (
                <Flex
                  w="100%"
                  h="100%"
                  alignItems="center"
                  justifyContent="center"
                >
                  {getIconForFileExt(ext)}
                </Flex>
              )}
            </Box>
            <Flex
              w="100%"
              // flex={.8}
              p={2}
              bg={colors.blueishGray50}
              alignItems="center"
              roundedBottom="4px"
            >
              <Box w="100%" h="20px" overflow="hidden">
                <Text noOfLines={1} fontSize={14} lineHeight={"16px"}>
                  {arquivo.nome || _nome}
                </Text>
              </Box>
            </Flex>
          </Link>
        </Flex>
        {arquivo.descricao ? (
          <Text noOfLines={2} fontSize={10} textAlign="center">
            {arquivo.descricao}
          </Text>
        ) : null}
      </Flex>
    </Tooltip>
  );
};

function ListaArquivos({ arquivos }: ListaArquivosProps) {
  return (
    <Flex gridGap={2} flexWrap="wrap">
      {arquivos.map((arquivo) => (
        <ArquivoItem arquivo={arquivo} key={arquivo.referencia} />
      ))}
    </Flex>
  );
}

export default ListaArquivos;
